import * as React from 'react';
import { useDispatch } from 'react-redux';
import { navigate } from 'gatsby';
import { BOOKING_URL } from 'core/constants';
import useTrackBookingStarted from 'analytics/ttd/hooks/useTrackBookingStarted';
import { PreselectBookingData } from '../lib/types';
import load from '../lib/loadBookingFlow';
import { setDigitalWalkIn, setStepValidated } from '../redux/actions';

type Handler = (data?: PreselectBookingData) => void;

export default function useStartBookingFlow(): Handler {
    const dispatch = useDispatch();
    const trackBookingStarted = useTrackBookingStarted();

    React.useEffect(() => {
        setTimeout(load, 1000);
        window.addEventListener('scroll', load, { once: true });
    }, []);

    return React.useCallback(
        function handleClick({
            locationId,
            date,
            time,
            provider,
            citySlug,
            locationSlug,
            isDigitalWalkIn,
        } = {}) {
            trackBookingStarted();
            load().then(
                ({
                    selectDate,
                    selectLocation,
                    selectTime,
                    selectProvider,
                }) => {
                    if (locationId) {
                        dispatch(setStepValidated('city', true));
                        dispatch(setStepValidated('location', true));
                        dispatch(selectLocation(locationId));
                    }

                    if (date) {
                        dispatch(selectDate(date));
                    }

                    if (time) {
                        dispatch(selectTime(time));
                    }

                    if (provider) {
                        dispatch(selectProvider(provider));
                    }

                    if (date && time) {
                        dispatch(setDigitalWalkIn(Boolean(isDigitalWalkIn)));
                        dispatch(setStepValidated('date', true));
                        navigate(
                            `/${BOOKING_URL}/${citySlug}/${locationSlug}/client`,
                            {
                                state: { locationId, date, time },
                            },
                        );
                    } else if (locationId && citySlug && locationSlug) {
                        navigate(
                            `/${BOOKING_URL}/${citySlug}/${locationSlug}`,
                            {
                                state: { locationId },
                            },
                        );
                    } else if (citySlug) {
                        navigate(`/${BOOKING_URL}/${citySlug}`);
                    } else {
                        navigate(`/${BOOKING_URL}/city`);
                    }
                },
            );
        },
        [dispatch, trackBookingStarted],
    );
}
